import * as React from "react";

const BlessArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={19} fill="none">
    <path
      fill="#121826"
      fillRule="evenodd"
      d="M7.716.054a1 1 0 0 1 1 1v13.761l4.253-4.252a1 1 0 1 1 1.414 1.414l-5.96 5.96a1 1 0 0 1-1.414 0l-5.96-5.96a1 1 0 1 1 1.415-1.414l4.252 4.252V1.054a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default BlessArrow;
